import Vue from "vue";
import Router from "vue-router";
import base from "../utils/api.js";
import api from "../utils/api";
import {
  aGet,
  aPost,
  upImg2
} from "../utils/request";
// import { Toast } from "mint-ui";
import store from '../store'
// import state from '../store/state.js'
import {
  Toast
} from "vant";
import index from "@/pages/index";
// 首页 原本的 ../pages/home/home.vue 统一使用 ../pages/home/Booth,减少相同页面
import home from "../pages/home/home.vue"
// 印迹
import Imprint from "../pages/Imprint/Imprint.vue"
// 我的
import my from "../pages/my/my.vue"

import adminDashboard from "../pages/admin/Dashboard.vue"

import Profile from "../pages/profile/Profile.vue"

// 爱窝
import cart from "../pages/cart/cart.vue"
// 谈宝
import scan from "../pages/scan/scan.vue"
// 断网
import nonet from "../pages/nonet/nonet.vue"
import nonetup from "../pages/nonet/nonetup.vue"
import nfc from "../utils/nfc";

Vue.use(Router);

//路由跳转不进行全局报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const homeRoute = {
  path: "home",
  name: 'home',
  component: home,
  meta: {
    index: 1,
    title: "首页",
    isBack: false,
    keepAlive: false
  },
}

const talkBabyRoute = {
  path: "/scan",
  component: scan,
  meta: {
    index: 1,
    title: ""
  },
  children: [
    //谈宝-谈宝
    {
      path: '/',
      name: 'talkbaby',
      component: () => import('../pages/scan/TalkBaby')
    },
    //谈宝-游戏
    {
      path: '/Game',
      name: 'game',
      component: () => import('../pages/scan/Game')
    },
    //谈宝-直播
    {
      path: '/Live',
      name: 'live',
      component: () => import('../pages/scan/Live')
    }
  ]
}

const adminDashboardRoute = {
  path: "/admin/dashboard",
  name: 'AdminDashboard',
  component: adminDashboard,
  meta: {
    index: 1,
    title: ""
  },
}

const myRoute = {
  path: "/my",
  name: 'my',
  component: my,
  meta: {
    index: 1,
    title: ""
  },
}

const cartRoute = {
  path: "/cart",
  component: cart,
  meta: {
    index: 1,
    title: ""
  }
}

const lotteryRoute = {
  path: '/Lottery',
  name: 'Lottery',
  component: () => import('../pages/my/Lottery')
}

const routes = [
  // {path: '/', redirect:'login'},
  // 有底部的动态路由
  {
    path: "/",
    // name: "home",
    redirect: "/home",  // 添加重定向到 /home
    component: index,
    // 启用预加载
    webpackPreload: true,
    children: [
      homeRoute, //
      talkBabyRoute,//谈宝
      lotteryRoute, // 抽奖
      myRoute,//我的
      cartRoute,//爱窝
      adminDashboardRoute, // 超管面板
      {
        path: '/like',
        component: () => import('../pages/Imprint/Like/Like.vue'),
        children: [
          //印记-我关注的-展台
          {
            path: '/',
            name: 'focusbooth',
            component: () => import('../pages/Imprint/FocusOn/FocusBooth')
          },
          //印记-我关注的-顾客
          {
            path: '/FocusClient',
            name: 'focusclient',
            component: () => import('../pages/Imprint/FocusOn/FocusClient')
          },
        ]
      },
      {
        path: "/profile",
        component: Profile,
        meta: {
          index: 1,
          title: ""
        },
        children: [
          {
            path: '/',
            name: 'Profile',
            component: () => import('../pages/profile/Profile.vue')
          },
          //印记-我割舍的 component: () => import('../pages/my/mySliding.vue')
          {
            path: '/profile/my',
            name: 'MyProfile',
            component: () => import('../pages/my/my.vue')
          },
        ]
      },
      {
        path: "/Imprint",
        component: Imprint,
        meta: {
          index: 1,
          title: ""
        },
        children: [
          //印记-我抢到的
          {
            path: '/',
            name: 'IBought',
            component: () => import('../pages/Imprint/Bought/Bought.vue')
          },
          {
            path: '/imprint/bought',
            name: 'Bought',
            component: () => import('../pages/Imprint/Bought/Bought.vue')
          },
          {
            path: '/imprint/sold',
            name: 'Sold',
            component: () => import('../pages/Imprint/Sold/Sold.vue')
          },

          {
            path: '/agent/order',
            name: 'AgentOrder',
            component: () => import('../pages/Imprint/Agent/AgentOrder.vue')
          },

          // {
          //   path: '/',
          //   name: 'iget',
          //   component: () => import('../pages/Imprint/IGet/IGet')
          // },
          //印记-我割舍的
          {
            path: '/GiveUp',
            name: 'giveup',
            component: () => import('../pages/Imprint/GiveUp/GiveUp')
          },
          //印记-我关注的
          {
            path: '/getAdver',
            component: () => import('../pages/Imprint/getAdver/getAdver'),
            children: [
              //印记-我关注的-展台
              {
                path: '/AdverInvite',
                name: 'AdverInvite',
                component: () => import('../pages/Imprint/getAdver/AdverInvite')
              },
              //印记-我关注的-顾客
              {
                path: '/AdverPass',
                name: 'AdverPass',
                component: () => import('../pages/Imprint/getAdver/AdverPass')
              },
              //印记-我关注的-顾客
              {
                path: '/AdverNotPass',
                name: 'AdverNotPass',
                component: () => import('../pages/Imprint/getAdver/AdverNotPass')
              },
            ]
          },
          {
            path: '/DownEdit',
            component: () => import('../pages/Imprint/DownEdit/DownEdit'),
            name: 'DownEdit',
            children: [
              //印记-我关注的-展台
              {
                path: '/SalesAdver',
                name: 'SalesAdver',
                component: () => import('../pages/Imprint/DownEdit/SalesAdver')
              },
              {
                path: '/MyPassAdver',
                name: 'MyPassAdver',
                component: () => import('../pages/Imprint/DownEdit/MyPassAdver')
              },
              {
                path: '/MyNotPassAdver',
                name: 'MyNotPassAdver',
                component: () => import('../pages/Imprint/DownEdit/MyNotPassAdver')
              },
            ]
          },

          {
            path: '/FocusOn',
            component: () => import('../pages/Imprint/FocusOn/FocusOn'),
            children: [
              //印记-我关注的-展台
              {
                path: '/',
                name: 'focusbooth',
                component: () => import('../pages/Imprint/FocusOn/FocusBooth')
              },
              //印记-我关注的-顾客
              {
                path: '/FocusClient',
                name: 'focusclient',
                component: () => import('../pages/Imprint/FocusOn/FocusClient')
              },
              {
                path: '/focus/agent/customer',
                name: 'FocusAgentCustomer',
                component: () => import('../pages/Imprint/FocusOn/FocusAgentCustomer.vue')
              },
            ]
          }
        ]
      },
      {
        path: '/booth',
        name: 'booth',
        //component: () => import('../pages/home/home.vue')
        component: () => import('../pages/home/home.vue')
      },
      {
        path: '/homeClone',
        name: 'homeClone',
        component: () => import('../pages/home/homeClone')
      },
      {
        path: '/store',
        name: 'store',
        component: () => import('../pages/home/store')
      },

      {
        path: '/store/list',
        name: 'Store List',
        component: () => import('../pages/store/StoreList.vue')
      },
      {
        path: '/knowledge',
        name: 'knowledge',
        component: () => import('../pages/home/knowledge')
      },
      //广告用户展台
      {
        path: '/knowledgeList',
        name: 'knowledgeList',
        component: () => import('../pages/home/knowledgeList'),
        // 启用预加载
        webpackPreload: true
      },
      {
        path: '/company',
        name: 'company',
        component: () => import('../pages/home/company')
      },
      {
        path: '/zudian',
        name: 'ZuDian',
        component: () => import('../pages/home/zudian')
      },
    ]
  },

  {
    path: '/profile/business-card',
    name: 'BusinessCard',
    component: () => import('../pages/profile/BusinessCard.vue')
  },

  {
    path: '/imprint/bought/detail',
    name: 'BoughtOrder',
    component: () => import('../pages/Imprint/Bought/BoughtDetail.vue')
  },
  {
    path: '/imprint/sold/detail',
    name: 'SoldOrderDetail',
    component: () => import('../pages/Imprint/Sold/SoldDetail.vue')
  },
  {
    path: '/imprint/sold/ship-order',
    name: 'ShipOrder',
    component: () => import('../pages/Imprint/Sold/ShipOrder.vue')
  },



  //用户展台
  {
    path: '/userBooth',
    name: 'userBooth',
    components: {
      intoBooth: () => import('../pages/home/UserBooth')
    },
  },
  //广告用户展台
  {
    path: '/AdvertisingBooth',
    name: 'advertisingbooth',
    component: () => import('../pages/home/AdvertisingBooth'),
    // 启用预加载
    webpackPreload: true
  },

  {
    path: '/category/list',
    name: 'CategoryList',
    component: () => import('../pages/category/CategoryList.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/category/manager',
    name: 'ContactManager',
    component: () => import('../pages/category/CategoryManager.vue'),
    // 启用预加载
    webpackPreload: true
  },



  {
    path: '/contact/info',
    name: 'ContactUserInfo',
    component: () => import('../pages/contact/ContactInfo.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/contact/join',
    name: 'ContactUserJoin',
    component: () => import('../pages/contact/ContactJoin.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/contact/cate/type1',
    name: 'ContactCategory1',
    component: () => import('../pages/contact/CategoryType1.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/contact/cate/type2',
    name: 'ContactCategory2',
    component: () => import('../pages/contact/CategoryType2.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/contact/manager/:showType',
    name: 'ContactManager',
    component: () => import('../pages/contact/ContactManager.vue'),
    // 启用预加载
    webpackPreload: true
  },

  {
    path: '/admin/user/manager',
    name: 'UserManager',
    component: () => import('../pages/admin/UserManager.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/admin/user/info',
    name: 'AdminUserInfo',
    component: () => import('../pages/admin/AdminUserInfo.vue'),
    // 启用预加载
    webpackPreload: true
  },

  {
    path: '/shelf/manager',
    name: 'Shelf Manager',
    component: () => import('../pages/shelf/ShelfManager.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/shelf',
    name: 'Shelf',
    component: () => import('../pages/shelf/shelf.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/resource/cart',
    name: 'ResourceCart',
    component: () => import('../pages/resource/ResourceCart.vue'),
    webpackPreload: true
  },
  {
    path: '/resource/cart/origin',
    name: 'ResourceCartOrigin',
    component: () => import('../pages/resource/ResourceCartOrigin.vue'),
    webpackPreload: true
  },
  {
    path: '/resource/manager',
    name: 'ResourceManager',
    component: () => import('../pages/resource/ResourceManager.vue'),
    webpackPreload: true
  },
  {
    path: '/resource/edit',
    name: 'ResourceEdit',
    component: () => import('../pages/resource/ResourceEdit.vue'),
    webpackPreload: true
  },
  {
    path: '/resource/view',
    name: 'ResourceView',
    component: () => import('../pages/resource/ResourceDetail.vue'),
    webpackPreload: true
  },
  {
    path: '/product/list',
    name: 'ProductList',
    component: () => import('../pages/product/ProductList.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/manager',
    name: 'ProductManager',
    component: () => import('../pages/product/ProductManager.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/create',
    name: 'CreateProduct',
    component: () => import('../pages/product/ProductCreate.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/edit',
    name: 'EditProduct',
    component: () => import('../pages/product/ProductEdit.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/form',
    name: 'ProductForm',
    component: () => import('../pages/product/form/ProductForm.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/shelf',
    name: 'ProductShelf',
    component: () => import('../pages/product/ProductShelf.vue'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/product/detail',
    name: 'ProductDetail',
    component: () => import('../pages/product/ProductDetail.vue'),
    // 启用预加载
    webpackPreload: true
  },
  //商品筛选
  // {path: '/filtrate/:filterName',name:'filtrate',component: ()=>import('../pages/home/Filtrate')},
  {
    path: '/filtrate',
    name: 'filtrate',
    component: () => import('../pages/home/Filtrate')
  },
  //商品详情
  {
    path: '/salesDetails',
    name: 'salesDetails',
    component: () => import('../pages/product/ProductDetail.vue'),
    // 启用预加载
    webpackPreload: true
  },
  //轮播图详情页面
  {
    path: '/SalesDetails2',
    name: 'SalesDetails2',
    component: () => import('../pages/home/SalesDetails2'),
    // 启用预加载
    webpackPreload: true
  },
  //轮播图详情页面
  {
    path: '/SalesDetails3',
    name: 'SalesDetails3',
    component: () => import('../pages/home/SalesDetails3'),
    // 启用预加载
    webpackPreload: true
  },
  {
    path: '/writeChip',
    name: 'writeChip',
    component: () => import('../pages/home/WriteChip.vue'),
    // 启用预加载
    webpackPreload: true
  },
  // 全部芯片码
  {
    path: '/allchipcode',
    name: 'allchipcode',
    component: () => import('../pages/home/AllChipCode')
  },
  // 芯片详情
  {
    path: '/chipDetail',
    name: 'chipDetail',
    component: () => import('../pages/home/ChipDetail')
  },
  // 温度数据
  {
    path: '/temperatureData',
    name: 'temperatureData',
    component: () => import('../pages/home/TemperatureData')
  },
  // 即时测量
  {
    path: '/instantMeasure',
    name: 'instantMeasure',
    component: () => import('../pages/home/InstantMeasure')
  },
  //商品详情-评论
  {
    path: '/evaluateCard',
    name: 'evaluateCard',
    component: () => import('../pages/home/Evaluate')
  },
  //搜索
  {
    path: '/Search',
    name: 'Search',
    component: () => import('../pages/home/Search'),
    meta: {
      keepAlive: false
    }
  },
  //登录
  {
    path: '/Login',
    name: 'login',
    component: () => import('../pages/Login/Login')
  },
  {
    path: '/app',
    name: 'AppBase',
    component: () => import('../pages/App/AppIndex.vue')
  },
  {
    path: '/app/:appType',
    name: 'AppWithType',
    component: () => import('../pages/App/AppIndex.vue')
  },
  {
    path: '/d',
    name: 'App',
    component: () => import('../pages/App/AppIndex.vue')
  },
  {
    path: '/direct',
    name: 'Direct',
    component: () => import('../pages/direct/Direct'),
  },
  //注册
  {
    path: '/Register',
    name: 'register',
    component: () => import('../pages/Login/Register')
  },
  //忘记密码
  {
    path: '/Forget',
    name: 'forget',
    component: () => import('../pages/Login/ForgetPassword')
  },
  //设置新密码
  {
    path: '/SetNewPwd',
    name: 'newpassword',
    component: () => import('../pages/Login/SetNewPwd')
  },
  //谈宝-发布谈宝视频
  {
    path: '/Publish',
    name: 'publish',
    component: () => import('../pages/scan/Publish')
  },
  // 谈宝-编辑谈宝
  {
    path: '/PublishEdit',
    name: 'publishedit',
    component: () => import('../pages/scan/PublishEdit')
  },
  //谈宝-发布谈宝图片
  {
    path: '/PublishImg',
    name: 'publishimg',
    component: () => import('../pages/scan/PublishImg')
  },
  // 谈宝-我发布的
  {
    path: '/MyDynamics',
    name: 'mydynamics',
    component: () => import('../pages/scan/MyDynamics')
  },
  //谈宝-谈宝详情
  {
    path: '/PublishDetail',
    name: 'publishdetail',
    component: () => import('../pages/scan/PublishDetail')
  },
  //印记-我抢到的-提交订单
  {
    path: '/SubmitOrder',
    name: 'submitorder',
    component: () => import('../pages/Imprint/IGet/SubmitOrder'),
    // meta:{keepAlive: true}
  },
  {
    path: '/order/checkout',
    name: 'ordercheckout',
    component: () => import('../pages/order/checkout'),
    // meta:{keepAlive: true}
  },
  //订单确认页面
  {
    path: '/order/checkout',
    name: 'ordercheckout',
    component: () => import('../pages/order/checkout'),
    meta: {
      index: 2,
      title: "订单确认",
      isBack: true,
      keepAlive: false
    }
  },
  // 用户地址管理
  {
    path: '/userAddress/list',
    name: 'userAddressList',
    component: () => import('../pages/userAddress/list'),
    meta: {
      index: 2,
      title: "地址管理",
      isBack: true,
      keepAlive: false
    }
  },
  // 用户地址编辑
  {
    path: '/userAddress/edit',
    name: 'userAddressEdit',
    component: () => import('../pages/userAddress/edit'),
    meta: {
      index: 3,
      title: "编辑地址",
      isBack: true,
      keepAlive: false
    }
  },
  // 我的
  {
    path: '/mySliding',
    name: 'mySliding',
    component: () => import('../pages/my/mySliding')
  },
  // 已购服务
  {
    path: '/service',
    name: 'service',
    component: () => import('../pages/my/service')
  },
  // 已购服务列表
  {
    path: '/purchased',
    name: 'purchased',
    component: () => import('../pages/my/purchased')
  },
  // 已购服务订单中心
  {
    path: '/buyservice',
    name: 'buyservice',
    component: () => import('../pages/my/buyservice')
  },
  //继续添加
  {
    path: '/AddAgain',
    name: 'addagain',
    component: () => import('../pages/Imprint/IGet/AddAgain')
  },
  // 协议
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../pages/my/agreement')
  },
  // 用户协议
  {
    path: '/Useragreement',
    name: 'Useragreement',
    component: () => import('../pages/my/Useragreement')
  },
  // 用户手册
  {
    path: '/UserInstructions',
    name: 'UserInstructions',
    component: () => import('../pages/my/UserInstructions')
  },
  // 隐私协议
  {
    path: '/Privacy',
    name: 'Privacy',
    component: () => import('../pages/my/Privacy')
  },
  // 地址
  {
    path: '/Residence',
    name: 'Residence',
    component: () => import('../pages/my/Residence')
  },
  // 新增地址
  {
    path: '/AddnewAddress',
    name: 'AddnewAddress',
    component: () => import('../pages/my/AddnewAddress')
  },
  // 编辑地址
  {
    path: '/Editaddress',
    name: 'Editaddress',
    component: () => import('../pages/my/Editaddress')
  },
  // 公告
  {
    path: '/Announcement',
    name: 'Announcement',
    component: () => import('../pages/my/Announcement')
  },
  // 新增公告
  {
    path: '/AddnewAnnouncement',
    name: 'AddnewAnnouncement',
    component: () => import('../pages/my/AddnewAnnouncement')
  },
  // 编辑公告
  {
    path: '/EditAnnouncement',
    name: 'EditAnnouncement',
    component: () => import('../pages/my/EditAnnouncement')
  },
  // 展台群
  {
    path: '/Group',
    name: 'Group',
    component: () => import('../pages/my/Group')
  },
  // 群邀请
  {
    path: '/Invitation',
    name: 'Invitation',
    component: () => import('../pages/my/Invitation')
  },
  // 创建之后的邀请页面
  {
    path: '/joingroup',
    name: 'joingroup',
    component: () => import('../pages/my/joingroup')
  },
  // 群详情
  {
    path: '/GroupDetail',
    name: 'GroupDetail',
    component: () => import('../pages/my/GroupDetail')
  },
  // 记事本
  {
    path: '/Notepad',
    name: 'Notepad',
    component: () => import('../pages/my/Notepad')
  },
  // 添加记事本
  {
    path: '/addNotepad',
    name: 'addNotepad',
    component: () => import('../pages/my/addNotepad')
  },
  // 编辑记事本
  {
    path: '/EditNotepad',
    name: 'EditNotepad',
    component: () => import('../pages/my/EditNotepad')
  },
  // 个人信息
  {
    path: '/accountInfo',
    name: 'accountInfo',
    component: () => import('../pages/my/accountInfo')
  },
  // 通讯录
  {
    path: '/addressbook',
    name: 'addressbook',
    component: () => import('../pages/my/addressbook/addressBook'),
    // meta: {
    //   keepAlive: true
    // }
  },
  // 流水账单
  {
    path: '/bill',
    name: 'bill',
    component: () => import('../pages/my/addressbook/bill')
  },
  // 通讯录详情
  {
    path: '/addressbookdetail',
    name: 'addressbookdetail',
    component: () => import('../pages/my/addressbook/addressBookDetail')
  },
  // 编辑通讯录
  {
    path: '/editaddressbook',
    name: 'editaddressbook',
    component: () => import('../pages/my/addressbook/editAddressBook')
  },
  // 通知
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../pages/my/addressbook/notice')
  },
  // 充值缴费
  {
    path: '/rechargepay',
    name: 'rechargepay',
    component: () => import('../pages/my/addressbook/rechargePay')
  },
  // 寄存列表
  {
    path: '/depositlist',
    name: 'depositlist',
    component: () => import('../pages/my/addressbook/depositList')
  },
  // 商品列表
  {
    path: '/productlist',
    name: 'productlist',
    component: () => import('../pages/my/addressbook/productList')
  },
  // 寄存详情
  {
    path: '/depositdetail',
    name: 'depositdetail',
    component: () => import('../pages/my/addressbook/depositDetail')
  },
  // 新建寄存
  {
    path: '/adddeposit',
    name: 'adddeposit',
    component: () => import('../pages/my/addressbook/addDeposit')
  },

  //谈宝
  // {
  //   path: "/scan",
  //   component: scan,
  //   meta: {
  //     index: 1,
  //     title: ""
  //   },
  //   children: [
  //     //谈宝-谈宝
  //     {
  //       path: '/',
  //       name: 'talkbaby',
  //       component: () => import('../pages/scan/TalkBaby')
  //     },
  //     //谈宝-游戏
  //     {
  //       path: '/Game',
  //       name: 'game',
  //       component: () => import('../pages/scan/Game')
  //     },
  //     //谈宝-直播
  //     {
  //       path: '/Live',
  //       name: 'live',
  //       component: () => import('../pages/scan/Live')
  //     }
  //   ]
  // },
  // 活动管理
  {
    path: '/activitymanage',
    name: 'activitymanage',
    component: () => import('../pages/my/activityManage/activityManage')
  },
  // 新建活动
  {
    path: '/addactivity',
    name: 'addactivity',
    component: () => import('../pages/my/activityManage/addActivity')
  },
  // 编辑活动
  {
    path: '/editactivity',
    name: 'editactivity',
    component: () => import('../pages/my/activityManage/editActivity')
  },
  // 活动详情
  {
    path: '/activitydetail',
    name: 'activitydetail',
    component: () => import('../pages/my/activityManage/activityDetail')
  },
  // 中奖名单
  {
    path: '/winninglist',
    name: 'winninglist',
    component: () => import('../pages/my/activityManage/winningList')
  },
  // 抽奖
  // {
  //   path: '/Lottery',
  //   name: 'Lottery',
  //   component: () => import('../pages/my/Lottery')
  // },
  // 抽奖记录
  {
    path: '/LotteryRecord',
    name: 'LotteryRecord',
    component: () => import('../pages/my/LotteryRecord')
  },
  // 我的奖品
  {
    path: '/MyLottery',
    name: 'MyLottery',
    component: () => import('../pages/my/MyLottery')
  },
  // 活动规则
  {
    path: '/activityrule',
    name: 'activityrule',
    component: () => import('../pages/my/activityManage/activityRule')
  },
  // 客服
  {
    path: '/customer',
    name: 'customer',
    component: () => import('../pages/my/customer')
  },
  // 添加客服
  {
    path: '/addcustomer',
    name: 'addcustomer',
    component: () => import('../pages/my/addcustomer')
  },
  // 编辑客服
  {
    path: '/editcustomer',
    name: 'editcustomer',
    component: () => import('../pages/my/editcustomer')
  },
  // 广告
  {
    path: '/Advertisement',
    name: 'Advertisement',
    component: () => import('../pages/my/Advertisement')
  },
  // 展厅广告申请展位
  {
    path: '/ApplyAdvertisement',
    name: 'ApplyAdvertisement',
    component: () => import('../pages/my/ApplyAdvertisement')
  },
  // 美工
  {
    path: '/artist',
    name: 'artist',
    component: () => import('../pages/my/artist')
  },
  // 美工详情
  {
    path: '/artistDetail',
    name: 'artistDetail',
    component: () => import('../pages/my/artistDetail')
  },
  // 美工需求
  {
    path: '/ArtistNeed',
    name: 'ArtistNeed',
    component: () => import('../pages/my/ArtistNeed')
  },
  // 美工选择
  {
    path: '/ArtistSelect',
    name: 'ArtistSelect',
    component: () => import('../pages/my/ArtistSelect')
  },
  // 美工已完成
  {
    path: '/artistComplete',
    name: 'artistComplete',
    component: () => import('../pages/my/artistComplete')
  },
  //展厅
  {
    path: '/Exhibition',
    name: 'Exhibition',
    component: () => import('../pages/my/Exhibition')
  },
  //创建商品
  {
    path: '/CreateProduct',
    name: 'CreateProduct',
    meta: {
      keepAlive: false
    },
    component: () => import('../pages/my/CreateProduct')
  },
  // 商品详情
  {
    path: '/ProductDetail',
    name: 'ProductDetail',
    component: () => import('../pages/my/ProductDetail')
  },
  {
    path: '/ProductDetail2',
    name: 'ProductDetail2',
    component: () => import('../pages/my/ProductDetail2')
  },
  {
    path: '/ProductDetail3',
    name: 'ProductDetail3',
    component: () => import('../pages/my/ProductDetail3')
  },
  {
    path: '/EditAdvert',
    name: 'EditAdvert',
    component: () => import('../pages/my/EditAdvert')
  },
  // 商品修改 复制自商品详情 增加弹出窗需要输入会员登录密码
  {
    path: '/ProductEdit',
    name: 'ProductEdit',
    component: () => import('../pages/my/ProductEdit'),
    // 启用预加载
    webpackPreload: true
  },
  //商品的类别
  {
    path: '/Category',
    name: 'Category',
    component: () => import('../pages/my/Category')
  },
  //记事本分类
  {
    path: '/MemoCategory',
    name: 'MemoCategory',
    component: () => import('../pages/my/MemoCategory')
  },
  // 用户信息
  {
    path: '/profile/store/info',
    name: 'StoreInfo',
    component: () => import('../pages/profile/store/StoreInfo.vue')
  },
  {
    path: '/profile/sub-store',
    component: () => import('../pages/profile/sub-store/SubStoreList.vue'),
    children: [
      {
        path: 'detail/:id',
        component: () => import('../pages/profile/sub-store/SubStoreDetail.vue')
      }
    ]
  },
  {
    path: '/profile/store-user',
    component: () => import('../pages/profile/store-user/StoreUserList.vue'),
    children: [
      {
        path: 'detail/:id',
        component: () => import('../pages/profile/store-user/StoreUserDetail.vue')
      },
    ]
  },
  {
    path: '/profile/store-user/edit',
    name: 'StoreUserEdit',
    component: () => import('../pages/profile/store-user/StoreUserEdit.vue')
  },
  {
    path: '/profile/store-user/wallet-log',
    name: 'WalletLog',
    component: () => import('../pages/profile/store-user/WalletLog.vue')
  },
  {
    path: '/profile/store-user/my-wallet-log',
    name: 'MyWalletLog',
    component: () => import('../pages/profile/store-user/MyWalletLog.vue')
  },
  {
    path: '/profile/my-wallet',
    name: 'MyWallet',
    component: () => import('../pages/profile/MyWallet.vue')
  },
  {
    path: '/profile/super-admin',
    name: 'SuperAdmin',
    component: () => import('../pages/profile/super-admin/SuperAdmin.vue'),
    meta: {
      index: 3,
      title: "超级管理",
      isBack: true,
      keepAlive: false
    }
  },

  //印记-我抢到的-等待商家接单
  {
    path: '/WaitingOrder',
    name: 'WaitingOrder',
    component: () => import('../pages/Imprint/IGet/WaitingOrder')
  },
  //印记-我抢到的-待支付
  {
    path: '/WaitingPay',
    name: 'WaitingPay',
    component: () => import('../pages/Imprint/IGet/WaitingPay')
  },
  //印记-我抢到的-订单待收货
  {
    path: '/WaitingGoods',
    name: 'WaitingGoods',
    component: () => import('../pages/Imprint/IGet/WaitingGoods')
  },
  //印记-我抢到的-订单完成
  {
    path: '/OrderCompletion',
    name: 'OrderCompletion',
    component: () => import('../pages/Imprint/IGet/OrderCompletion')
  },
  //印记-我抢到的-订单评价
  {
    path: '/orderEvaluate',
    name: 'orderEvaluate',
    component: () => import('../pages/Imprint/IGet/orderEvaluate')
  },
  //印记-收款码
  {
    path: '/MoneyCode',
    name: 'MoneyCode',
    component: () => import('../pages/Imprint/MoneyCode')
  },
  {
    path: '/pay/code',
    name: 'PayCode',
    component: () => import('../pages/Imprint/PayCode.vue')
  },
  //印记-我割舍的-订单待确认
  {
    path: '/OrderBeConfirmed',
    name: 'OrderBeConfirmed',
    component: () => import('../pages/Imprint/GiveUp/OrderBeConfirmed')
  },
  //印记-我割舍的-订单待收款
  {
    path: '/OrderWaitPay',
    name: 'OrderWaitPay',
    component: () => import('../pages/Imprint/GiveUp/OrderWaitPay')
  },
  //印记-我割舍的-订单待发货
  {
    path: '/WaitDeliverGoods',
    name: 'WaitDeliverGoods',
    component: () => import('../pages/Imprint/GiveUp/WaitDeliverGoods')
  },
  //印记-我割舍的-发货员选择
  {
    path: '/DeliveryMan',
    name: 'deliveryman',
    component: () => import('../pages/Imprint/GiveUp/DeliveryMan')
  },
  //印记-我割舍的-发货
  {
    path: '/DeliverGoods',
    name: 'delivergoods',
    component: () => import('../pages/Imprint/GiveUp/DeliverGoods')
  },
  //印记-我割舍的-订单已完成
  {
    path: '/OrderOver',
    name: 'OrderOver',
    component: () => import('../pages/Imprint/GiveUp/OrderOver')
  },
  // 修改密码
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: () => import('../pages/my/ChangePassword')
  },
  // 修改绑定手机
  {
    path: '/ChangePhone',
    name: 'ChangePhone',
    component: () => import('../pages/my/ChangePhone')
  },
  // 注销用户
  {
    path: '/cancellation',
    name: 'cancellation',
    component: () => import('../pages/my/cancellation')
  },
  //我的模板
  {
    path: '/getMyTemplate',
    name: 'getMytemplate',
    component: () => import('../pages/my/getMyTemplate')
  },
  // 模板库
  {
    path: '/getTemplate',
    name: 'getTemplate',
    component: () => import('../pages/my/getTemplate')
  },
  // 创建模板
  {
    path: '/CreateTemplate',
    name: 'CreateTemplate',
    component: () => import('../pages/my/CreateTemplate')
  },
  // 我的模板详情
  {
    path: '/myTemplateDetail',
    name: 'myTemplateDetail',
    component: () => import('../pages/my/myTemplateDetail')
  },
  // 平台模板库
  {
    path: '/TemplateSuccessPay',
    name: 'TemplateSuccessPay',
    component: () => import('../pages/my/TemplateSuccessPay')
  },
  // 平台模板库详细
  {
    path: '/TemplateSuccessDetail',
    name: 'TemplateSuccessDetail',
    component: () => import('../pages/my/TemplateSuccessDetail')
  },
  // 创建完成之后
  {
    path: '/CreateTemplateSuccess',
    name: 'CreateTemplateSuccess',
    component: () => import('../pages/my/CreateTemplateSuccess')
  },
  // 新建模板
  {
    path: '/NewCreateTemplate',
    name: 'NewCreateTemplate',
    component: () => import('../pages/my/NewCreateTemplate')
  },
  // 背景图
  {
    path: '/BackgroundImg',
    name: 'BackgroundImg',
    component: () => import('../pages/my/BackgroundImg')
  },
  // 发布背景图需求
  {
    path: '/BackgroundNeed',
    name: 'BackgroundNeed',
    component: () => import('../pages/my/BackgroundNeed')
  },
  // 背景美工列表
  {
    path: '/BackgoundSelect',
    name: 'BackgoundSelect',
    component: () => import('../pages/my/BackgoundSelect')
  },
  // 背景已完成
  {
    path: '/backgoundComplete',
    name: 'backgoundComplete',
    component: () => import('../pages/my/backgoundComplete')
  },
  // 背景详细
  {
    path: '/backgoundDetail',
    name: 'backgoundDetail',
    component: () => import('../pages/my/backgoundDetail')
  },
  // 购买背景图
  {
    path: '/buyBackgound',
    name: 'buyBackgound',
    component: () => import('../pages/my/buyBackgound')
  },
  // 上传背景图
  {
    path: '/UploadImg',
    name: 'UploadImg',
    component: () => import('../pages/my/UploadImg')
  },
  // 展厅补货
  {
    path: '/Replenishment',
    name: 'Replenishment',
    component: () => import('../pages/my/Replenishment')
  },
  // 展厅添加模板
  {
    path: '/AddTemplate',
    name: 'AddTemplate',
    component: () => import('../pages/my/AddTemplate')
  },
  // 展厅添加模板下的我的模板库
  {
    path: '/AddTemplateSelect',
    name: 'AddTemplateSelect',
    component: () => import('../pages/my/AddTemplateSelect')
  },
  // 发布补货
  {
    path: '/Releasegoods',
    name: 'Releasegoods',
    component: () => import('../pages/my/Releasegoods')
  },
  // 我的页面补货
  {
    path: '/Supplement',
    name: 'Supplement',
    component: () => import('../pages/my/Supplement')
  },
  // 补货付款页面
  {
    path: '/ReplenishmentPay',
    name: 'ReplenishmentPay',
    component: () => import('../pages/my/ReplenishmentPay')
  },
  // 补货订单详情页面
  {
    path: '/ReplenishmentOrder',
    name: 'ReplenishmentOrder',
    component: () => import('../pages/my/ReplenishmentOrder')
  },
  // 补货里我收到的报价页面
  {
    path: '/Newoffer',
    name: 'Newoffer',
    component: () => import('../pages/my/Newoffer')
  },
  // 补货里我收到的收款页面
  {
    path: '/collections',
    name: 'collections',
    component: () => import('../pages/my/collections')
  },
  // 补货里我收到的收款页面之后发货页面
  {
    path: '/Delivery',
    name: 'Delivery',
    component: () => import('../pages/my/Delivery')
  },
  // 补货查看商品页面
  {
    path: '/ReplenishmentCheek',
    name: 'ReplenishmentCheek',
    component: () => import('../pages/my/ReplenishmentCheek')
  },
  // 补货待收款待支付页面详情
  {
    path: '/Getreceived',
    name: 'Getreceived',
    component: () => import('../pages/my/Getreceived')
  },
  // 补货的发货页面
  {
    path: '/shipments',
    name: 'shipments',
    component: () => import('../pages/my/shipments')
  },

  {
    path: '/imprint/sold/ship-order',
    name: 'ShipOrder',
    component: () => import('../pages/Imprint/Sold/ShipOrder.vue')
  },
  //扫码页面
  {
    path: '/SendSalesScan',
    name: 'sendsalesscan',
    component: () => import('../pages/Imprint/GiveUp/SendSalesScan')
  },
  // 二维码
  {
    path: '/scanformy',
    name: 'scanformy',
    component: () => import('../pages/my/scanformy')
  },
  // 通用扫码页面
  {
    path: '/scan/universal',
    name: 'UniversalScan',
    component: () => import('../pages/scan/UniversalScan'),
    meta: {
      title: '扫码录入',
      noCache: true
    }
  },

  {
    path: '/nonetup',
    name: 'nonetup',
    component: () => import('../pages/nonet/nonetup')
  }, {
    path: '/downproducts',
    name: 'downproducts',
    component: () => import('../pages/my/downproducts')
  },
  //离线上传页面
  {
    path: '/upproducts',
    name: 'upproducts',
    component: () => import('../pages/my/upproducts')
  }, ,
  //离线上传页面
  {
    path: '/upproducts',
    name: 'upproducts',
    component: () => import('../pages/my/upproducts')
  },
  //离线上传页面
  {
    path: '/upproducts',
    name: 'upproducts',
    component: () => import('../pages/my/upproducts')
  },
  //上传挂在轮播下广告的页面
  {
    path: '/CreateProduct2',
    name: 'CreateProduct2',
    component: () => import('../pages/my/CreateProduct2')
  },
  // 相关链接
  {
    path: '/store/external-link',
    name: 'External Link',
    component: () => import('../pages/store/external-link/index.vue'),
    webpackPreload: true
  },
  {
    path: '/store/external-link/:action',
    name: 'Edit External Link',
    component: () => import('../pages/store/external-link/edit.vue')
  },
  // 添加短链接重定向路由
  {
    path: '/s/:code',
    name: 'ShortLinkRedirect',
    component: () => import('../pages/shortLink/ShortLinkRedirect'),
    meta: { title: '短链接跳转', noCache: true }
  },
  {
    path: '/short-link/list',
    name: 'ShortLinkList',
    component: () => import('../pages/shortLink/ShortLinkList.vue'),
    // 启用预加载
    webpackPreload: true
  },
];

const routerMode = process.env.VUE_APP_ROUTER_MODE || 'hash';
const appType = process.env.VUE_APP_TYPE_NAME.toLowerCase() || ''
let basePath = '/'
// if ((routerMode === 'history') && (appType !== '')) {
//   basePath = `/${process.env.VUE_APP_TYPE_NAME.toLowerCase()}/`
// }
const router = new Router({
  mode: routerMode,
  base: basePath, //确保base 为 /
  routes
});

console.log(`当前路由模式:${routerMode} 基础路径: ${basePath}`)


/*router.beforeEach((to, from, next) => {

  if (to.path === '/Login' || to.path === '/agreement' || to.path === '/setpassword' || to.path === '/verification') {
    next()
  } else {
    if (localStorage.getItem("id")) {
      next();
    } else {
      // Toast({ message: '请先登录', position: 'bottom', duration: 1000 })
      setTimeout(function () {
        next({ path: '/', component: register, meta: { title: "注册" } })
      }, 1000)
    }
  }
  if(to.path==='/scan'){

  }
next();
});*/
router.beforeEach((to, from, next) => {
  let linkArr = ['/imprint/bought/view', '/app', '/imprint/bought/view', '/Login', '/direct',  '/Register', '/Privacy', '/Forget', '/ChangePassword', '/Useragreement', '/SetNewPwd',
    '/salesDetails', '/nonet', '/Lottery', '/booth', '/AdvertisingBooth', '/homeClone', '/store', '/company', '/zudian', '/knowledge', '/homeclone',
    '/chipDetail', '/allchipcode', '/shelf', '/resource/cart', '/product/shelf', '/product/list', '/product/detail', '/resource/view', '/category/list',
    'PublishDetail', '/contact/join', '/MoneyCode', '/temperatureData', '/instantMeasure'
  ] //这里应该是不需要登录的权限
  let linkPath = linkArr.includes(to.path);


  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isWebView = /wv|WebView/i.test(userAgent);

  // 检查提示的显示状态
  const expirationTime = localStorage.getItem('downloadHintExpiration');
  const currentTime = new Date().getTime();

  if (!isWebView && (!expirationTime || currentTime > expirationTime)) {
    // 如果不是 WebView 且提示已经过期或未设置，显示提示
    store.commit('setHintVisible', true);
  } else {
    // 否则，隐藏提示
    store.commit('setHintVisible', false);
  }


  console.log(`------判断当前路径:${to.path} ${linkPath} `)
  if (linkPath || to.path.startsWith('/app') || to.path.startsWith('/s/') ) {
    // console.log("这里是不需要登录...")
    store.dispatch('setHomePop', false)
    next()
  } else {

    //localStorage.getItem("id")用户ID
    //localStorage.getItem('storeId')展台ID
    if (localStorage.getItem("id")) {
      // let pathArr = ['/imprint','/mySliding','/Residence','/Group','/Notepad','/customer','/Advertisement','/Exhibition','/Supplement','/artist']
      // let toPath = pathArr.includes(to.path)
      // if(toPath) {


      let parma = {
        storeId: JSON.parse(localStorage.getItem('storeId'))
      }

      //alert(localStorage.getItem('storeId')) ;

      if (navigator.onLine) {
        console.log("-----------route before Each ", from.path, to.path)
        let writeModePaths = ["/shelf/manager", "/WriteChip", "/resource/manager", "/mySliding"]
        //如果不包含
        if (writeModePaths.indexOf(to.path) === -1) {
          console.log("--------NFC 强制转换为读取模式")
          nfc.forceReadDataMode()
        }

        aGet(api.getStoreItem, parma).then(res => {


          let storeItem = res.data.data
          //  console.log('是否需要密码',storeItem);
          if (to.path == '/imprint' && storeItem[0].status == 1) {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/mySliding' && storeItem[1].status == 1) {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Residence' && storeItem[2].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Announcement' && storeItem[2].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Group' && storeItem[3].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Group' && storeItem[3].status == 1 && from.path == '/') { //
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Notepad' && storeItem[4].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/customer' && storeItem[5].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Advertisement' && storeItem[6].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Exhibition' && storeItem[7].status == 1 && (from.path == '/my' || from.path ==
            '/')) {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/ProductEdit' || to.path == '/productedit' || to.path == '/productEdit') {
            //编辑商品设置为需要密码
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/Supplement' && storeItem[8].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else if (to.path == '/artist' && storeItem[9].status == 1 && from.path == '/my') {
            store.commit('SET_PASSWORD_STATUS', true)
            next()
          } else {
            //  alert("不需要二级密码");
            store.commit('SET_PASSWORD_STATUS', false)
            next()
          }
        })
      } else {
        // alert("掉线了");
        const conn = window.indexedDB.open('tts', 1);
        conn.onsuccess = function (event) {
          var db = event.target.result;
          var request = db.transaction('storeItem').objectStore('storeItem').getAll();
          request.onsuccess = async function (event) {
            if (request.result) {
              var obj = request.result;

              let storeItem = obj
              if (to.path == '/imprint' && storeItem[0].status == 1) {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/mySliding' && storeItem[1].status == 1) {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Residence' && storeItem[2].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Announcement' && storeItem[2].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Group' && storeItem[3].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Group' && storeItem[3].status == 1 && from.path == '/') { //
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Notepad' && storeItem[4].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/customer' && storeItem[5].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Advertisement' && storeItem[6].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Exhibition' && storeItem[7].status == 1 && (from.path == '/my' || from
                .path == '/')) {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/ProductEdit' || to.path == '/productedit' || to.path ==
                '/productEdit') { //编辑商品设置为需要密码
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/Supplement' && storeItem[8].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else if (to.path == '/artist' && storeItem[9].status == 1 && from.path == '/my') {
                store.commit('SET_PASSWORD_STATUS', true)
                next()
              } else {
                store.commit('SET_PASSWORD_STATUS', false)
                next()
              }
            }
          };
        }

      }


    } else {
      // 未登录，检查是否有用户名和密码参数
      const {username, password} = to.query;

      if (username && password) {
        // 如果有用户名和密码参数，自动登录
        store.dispatch('login', {username, password}).then(() => {
          next();
        }).catch(() => {
          next('/Login');
        });
      } else {

        console.log("---登录前保存访问的页面路径")
        localStorage.setItem("last_path", to.path);
        localStorage.setItem("last_query", JSON.stringify(to.query));
        localStorage.setItem("last_params", JSON.stringify(to.params));

        // 如果没有参数，跳转到登录页面
        Toast({
          message: '请先登录',
          position: 'bottom',
          duration: 1000
        });

        setTimeout(() => {
          next({
            path: '/Login',
            query: {redirect: to.fullPath}
          });
        }, 1000);
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js